import { createSlice } from '@reduxjs/toolkit';

import { dispatch } from '../store';
import { ProfileState } from '../../@types/profile/types';
import aspUserService from '../../services/asp-identity/aspUserService';

// ----------------------------------------------------------------------

const initialState: ProfileState = {
  profile: null,
  fetchTime: null,
};

const slice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    clearState(state) {
      state.profile = initialState.profile;
      state.fetchTime = initialState.fetchTime;
    },

    setProfile(state, action) {
      state.profile = action.payload;
    },

    setFetchTime(state, action) {
      state.fetchTime = action.payload;
    },
  },
});

export const fetchProfile = async () => {
  try {
    const data = await aspUserService.getProfile();

    dispatch(slice.actions.setProfile(data));
    dispatch(slice.actions.setFetchTime(Number(Date.now())));
  } catch (error) {
    console.error(error);
  }
};

export const getFetched = () => {};

// Reducer
export default slice.reducer;
